
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 35.767 18.714"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 314","transform":"translate(-6900.642 -1411.916)","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"Path 561","d":"M6935.162 1421.275a20.741 20.741 0 01-33.272 0 20.734 20.734 0 0133.272 0z"}}),_c('circle',{attrs:{"data-name":"Ellipse 33","cx":"5.468","cy":"5.468","r":"5.468","transform":"translate(6913.058 1415.805)"}})])])
          )
        }
      }
    